import React from 'react'
import Chart from "react-apexcharts";

const RightSide = () => {
  return (
    <div className='rightcon'>
        <div className="chartcon">
           <Donut/>
        </div>
        <div className="message">

        </div>
    </div>
  )
}
function Donut(){
    const options={
        chart:{
            type:'donut',
            height:200
        },
           plotOptions: {
            pie: {
                donut: {
                    size: '65%' 
                }
            }
        },
        series:[50,50,50,50],
        labels:['Sale','Revenue','Expenses','Others'],
        colors:["#fca61f","#788097","#FF919D","#f799a354"],
        dataLabels: {
            enabled: false,
          },
          stroke:{
            width:0,
          },
         legend: {
            show: false 
        }
          
      
            }
        
    
    return(
          
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent:'center',
            alignItems: 'center',
            gap: '20px'
        }}>
    
            <Chart 
                options={options} 
                series={options.series} 
                type='donut'
                width={200} 
                height={200} 
            />
            
       
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                width: '100%',
                maxWidth: '330px'
            }}>
                {options.labels.map((label, index) => (
                    <div key={index} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <div style={{
                            width: '12px',
                            height: '12px',
                            backgroundColor: options.colors[index],
                            borderRadius: '50%'
                        }} />
                        <span>{label}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default RightSide